import Api from './../api'

export default DataLayer => DataLayer.$extend('episodes', {
    getByDate(channel, startdate, enddate) {
        return Api.episodes.find({ channel, startdate: startdate.toISOString(), enddate: enddate.toISOString() })
    },
})
